export const ROUTE_PORTAL_NAME = "FIDO Portal";

// Browse Routes
export const ROUTE_BROWSE_WAYPOINTS_INTERACTIVE =
  "/app/browse/interactive/waypoints";
export const ROUTE_BROWSE_WAYPOINTS_LIST = "/app/browse/list/waypoints";
export const ROUTE_BROWSE_SESSIONS_INTERACTIVE =
  "/app/browse/interactive/sessions";
export const ROUTE_BROWSE_SESSIONS_LIST = "/app/browse/list/sessions";
export const ROUTE_BROWSE_SENSORS_INTERACTIVE =
  "/app/browse/interactive/sensors";
export const ROUTE_BROWSE_SENSORS_LIST = "/app/browse/list/sensors";
export const ROUTE_BROWSE_RELAYS_INTERACTIVE = "/app/browse/interactive/relays";
export const ROUTE_BROWSE_RELAYS_LIST = "/app/browse/list/relays";
export const ROUTE_BROWSE_JOBS_INTERACTIVE = "/app/browse/interactive/jobs";
export const ROUTE_BROWSE_JOBS_LIST = "/app/browse/list/jobs";
export const ROUTE_BROWSE_LOGS_INTERACTIVE =
  "/app/browse/interactive/waypoint-logs";
export const ROUTE_BROWSE_LOGS_LIST = "/app/browse/list/waypoint-logs";
// Header slot keys (used in route handles + header slot registry)
export const HEADER_SLOT = {
  BROWSE_VIEW_SWITCH: "browse-view-switch",
  PROJECT_ACTIONS: "project-actions",
  WAYPOINT_ACTIONS: "waypoint-actions"
} as const;

// Note: src/utils/getRoute.ts can be used to generate old single page routes
